import { type DiscoverChatbotProfileOverlayViewProps } from "@next-platform/client-common-core";
import { Button, ButtonVariant } from "@next-platform/client-common-spicy-ui";
import React from "react";

import DiscoverChatbotProfileOverlaySkeleton from "./DiscoverChatbotProfileOverlaySkeleton";

const DEFAULT_TEST_ID = "DiscoverChatbotProfileOverlayStatus";

type Props = Pick<DiscoverChatbotProfileOverlayViewProps, "labels" | "status" | "onRetry"> & {
  readonly testID?: string;
};

// Classname constants
const WRAPPER_CLASSNAME = "flex flex-col items-center gap-4 px-[6vw] py-[6vw] w-full max-w-[416px] md:max-w-[540px] mx-auto";
const MESSAGE_CLASSNAME = "text-sm text-neutral-700 dark:text-neutral-200 text-center";

const DiscoverChatbotProfileOverlayStatus: React.FC<Props> = ({ status, labels, onRetry, testID }) => {
  if (status === "loading") {
    return <DiscoverChatbotProfileOverlaySkeleton testID={`${testID}-Skeleton`} />;
  }

  // ready: render nothing
  if (status === "ready") {
    return null;
  }

  // error or not found
  const isNotFound = status === "not-found";
  return (
    <div className={WRAPPER_CLASSNAME} data-testid={testID ?? DEFAULT_TEST_ID}>
      <div className={MESSAGE_CLASSNAME} data-testid={`${testID ?? DEFAULT_TEST_ID}-StatusMessage`}>
        {isNotFound ? labels.notFound : labels.error}
      </div>
      {status === "error" ? (
        <Button
          variant={ButtonVariant.OUTLINED}
          className="font-semibold"
          data-testid={`${testID ?? DEFAULT_TEST_ID}-RetryButton`}
          onClick={onRetry}
          type="button"
        >
          {labels.retry}
        </Button>
      ) : null}
    </div>
  );
};

export default DiscoverChatbotProfileOverlayStatus;
